<template>
  <div>
    <v-row v-if="inventory">
      <v-col cols="12" v-for="(item, i) in inventory.form" :key="i">
        <h4>{{ item.label }}</h4>
        <v-text-field
          v-if="item.type == 'text'"
          class="mt-2 rounded-lg"
          dense
          v-model="inventory.body[item.key]"
          placeholder="Type here"
          hide-details
          color="green"
        ></v-text-field>
        <v-select
          v-if="item.type == 'select' && item.key == 'province' && province"
          :loading="loadCity"
          :disabled="loadCity"
          :items="province"
          @change="getCity(inventory.body[item.key])"
          item-text="name"
          item-value="id"
          class="mt-2 rounded-lg"
          dense
          v-model="inventory.body[item.key]"
          placeholder="click here"
          hide-details
          color="green"
        ></v-select>
        <v-select
          v-if="item.type == 'select' && item.key == 'city' && city"
          :loading="loadCity"
          :disabled="loadCity"
          :items="city"
          item-text="name"
          item-value="id"
          class="mt-2 rounded-lg"
          dense
          v-model="inventory.body[item.key]"
          placeholder="click here"
          hide-details
          color="green"
        ></v-select>
        <v-menu
          v-if="item.type == 'date'"
          v-model="showPickerStart"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="inventory.body[item.key]"
              prepend-inner-icon="mdi-calendar-range"
              readonly
              dense
              color="green"
              hide-details
              v-on="on"
              placeholder="Click here"
              class="rounded-lg"
            ></v-text-field>
          </template>
          <div>
            <v-date-picker v-model="inventory.body[item.key]"></v-date-picker>
          </div>
        </v-menu> 

        <v-textarea
          v-if="item.type == 'textarea'"
          class="mt-2 rounded-lg"
          v-model="inventory.body[item.key]"
          rows="4"
          placeholder="Type here"
          color="green"
          dense
          hide-details
        ></v-textarea>
      </v-col>
    </v-row>
    <div class="d-flex justify-end mt-3">
      <v-btn
        depressed
        color="var(--g)"
        dark
        class="text-capitalize"
        @click="postData"
        >Save</v-btn
      >
    </div>
    <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "createupdateup",
  props: ["inventory"],
  data() {
    return {
      sector: null,
      province: null,
      city: null,
      loadCity: false,
      loading: false,
      showPickerStart: false,
      time: null,
      menu2: false,
    };
  },
  mounted() {
    this.getSector();
    this.getProvince();
  },
  methods: {
    getSector() {
      this.loading = true;
      let data = {
        path: `univ-partner/sector`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.sector = data.data;
          this.sector.forEach((el) => {
            el.id = `${el.id}`;
          });
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getProvince() {
      this.loading = true;
      let data = {
        path: `region/province`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.province = data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getCity(id) {
      this.inventory.city = "";
      this.loadCity = true;
      let data = {
        path: `region/regency?province_id=${id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.city = data;
          this.loadCity = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loadCity = false;
        });
    },
    postData() {
      this.loading = true;
      let data = {
        path: this.inventory.path,
        body: this.inventory.body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          for (let i in this.inventory.body) {
            this.inventory.body[i] = "";
          }
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>
